import React from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as auth from "../Auth/_redux/authRedux";
import MyInvitations from "../../../components/MyInvitations";
import "./onboarding.scss";

// Shown when the account is valid but has no usable organisation (for example the only organisation it
// belonged to was archived). No operational data or navigation: only invitations, the account's own
// details, and sign out. The backend (getUserIdfromToken + NO_ORGANISATION_ALLOWLIST) enforces the same.
export default function NoOrganisation() {
    const dispatch = useDispatch();
    const { currentUser } = useSelector(({ auth }) => ({ currentUser: auth.user && auth.user.user }), shallowEqual);

    return (
        <div className="onboarding-shell">
            <div className="onboarding-card" data-testid="no-organisation">
                <h3 className="mb-2">No active organisation</h3>
                <p className="text-muted mb-8">
                    Your account is active, but it is not currently part of an active organisation. If an organisation has invited you,
                    accept the invitation below to continue. Your account and history are kept.
                </p>

                <h5 className="mb-4">Invitations</h5>
                <MyInvitations onAccepted={() => window.location.assign("/dashboard")} />

                <h5 className="mt-10 mb-4">Your account</h5>
                <div className="text-muted mb-1">
                    {currentUser ? `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim() : ""}
                </div>
                <div className="mb-8">{currentUser && currentUser.email}</div>

                <button type="button" className="btn btn-light-primary" onClick={() => dispatch(auth.actions.logout())}>
                    Log out
                </button>
            </div>
        </div>
    );
}
